// extracted by mini-css-extract-plugin
module.exports = {"container":"ThemeSwitcher_container__MOp2g","iconHolder":"ThemeSwitcher_iconHolder__1sbY9","icon":"ThemeSwitcher_icon__38LMM"};